import { reactive } from "vue";

export const store = reactive({
    wmid: 0,
    sid: undefined,
    env: "uat",
    toolHash: {},
    lang: "en",
});
